import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const flags = {
  fr: (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" className="rounded-sm">
      <rect width="8" height="16" fill="#002395" />
      <rect x="8" width="8" height="16" fill="#FFFFFF" />
      <rect x="16" width="8" height="16" fill="#ED2939" />
    </svg>
  ),
  en: (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" className="rounded-sm">
      <rect width="24" height="16" fill="#012169" />
      <path d="M0 0L24 16M24 0L0 16" stroke="white" strokeWidth="2.5" />
      <path d="M0 0L24 16M24 0L0 16" stroke="#C8102E" strokeWidth="1.5" />
      <path d="M12 0V16M0 8H24" stroke="white" strokeWidth="4" />
      <path d="M12 0V16M0 8H24" stroke="#C8102E" strokeWidth="2.5" />
    </svg>
  ),
  lv: (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" className="rounded-sm">
      <rect width="24" height="16" fill="#9E3039" />
      <rect y="6" width="24" height="4" fill="#FFFFFF" />
    </svg>
  ),
};

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  const languages = [
    { code: 'fr', label: 'FR' },
    { code: 'en', label: 'EN' },
    { code: 'lv', label: 'LV' },
  ];

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`flex items-center gap-1.5 px-2 py-1.5 rounded transition-all ${
            language === lang.code
              ? 'bg-[#d9fb06]/20 ring-1 ring-[#d9fb06]/50'
              : 'hover:bg-[#3f4816]/30 opacity-60 hover:opacity-100'
          }`}
          title={lang.label}
        >
          {flags[lang.code]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
